import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const enrichmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REF_DATA_ENRICH_SETUPS:
            return {
                ...state,
                refDataEnrichments: action.payload,
            };
        case actionTypes.GET_REF_DATA_ENRICH_CONFIGS:
            return {
                ...state,
                refDataEnrichConfigs: action.payload,
            };
        default:
            return state;
    }
};

export default enrichmentReducer;
